export default {
  // 日期选择器
  dateRangeSeparator: "→",
  startDatePlaceholder: "开始日期",
  endDatePlaceholder: "结束日期",

  // 按钮
  reset: "重置",
  query: "查询",

  // 数据统计
  totalData: "共计{count}条数据",

  // 加载
  loading: "拼命加载中",

  // 行为类型
  withdrawal: "提现",
  deposit: "充值",
  buy: "买入",
  sell: "卖出",
  unknown: "未知",

  // 加载更多
  loadMore: "加载更多数据",
  collapse: "收起",

  // 空状态
  noData: "暂无数据",
};
